export function getStartPreviousCalendarMonthIsh(): Date {
  const now = new Date();

  // If it's on/after the 24th, use the current month.
  // Otherwise, use the previous calendar month.
  let year = now.getFullYear();
  let month = now.getMonth(); // 0-based (0 = January)

  if (now.getDate() <= 23) {
    month -= 1;
    if (month < 0) {
      month = 11; // December
      year -= 1; // Previous year
    }
  }

  // Return the first day of the chosen month at midnight.
  return new Date(year, month, 1, 0, 0, 0, 0);
}
